import React from 'react';
import PropTypes from 'prop-types';
import Image from '../../../../shared/Image';
import productSalesIcon from '../../../../../../images/icons/icon-dollar-blue.svg';
import { openModal } from '../ProductSalesEducationModal';
import analytics from '../../../../../modules/analytics';
import '../../Notification.scss';
import './ProductSalesNotification.scss';
import { ModalContextPropType } from '../../../../ui/ModalContext';

/**
 * Add Gift Card notification
 */
const ProductSalesNotification = ({
  modalContext,
  notification: {
    provider_id: providerId,
  },
}) => (
  <button
    type="button"
    onClick={() => {
      analytics.track('product_sales_education_modal_opened_from_notification');
      openModal(modalContext, { providerId });
    }}
    className="button-notification"
  >
    <section className="notification">
      <div className="icon">
        <Image
          source={{
            uri: productSalesIcon,
            width: 23,
            height: 32,
            resizeMode: 'center',
          }}
        />
      </div>
      <section className="notification-body short-block">
        <div className="notification-text">
          <strong>
            Add a product, boost your sales!
          </strong>
          <p className="notification-indent">
            Now, you can list products on your profile to easily sell your tried-and-true
            recommendations to clients. Reach out to your clients to make sure they know!
          </p>
          <strong className="notification-get-started">Get Started</strong>
        </div>
      </section>
    </section>
  </button>
);

ProductSalesNotification.propTypes = {
  modalContext: ModalContextPropType,
  notification: PropTypes.shape({
    provider_id: PropTypes.number,
  }).isRequired,
};

ProductSalesNotification.defaultProps = {
  modalContext: null,
};

export default ProductSalesNotification;
